module.exports = __webpack_public_path__ + "static/media/longford.d98423b5.png";